import { ReactNode } from 'react'
import Text from 'shared/components/typography/Text'
import s from './s.module.css'

interface Props {
  children: ReactNode
  isRequired?: boolean
}

function Label({ children, isRequired }: Props) {
  return (
    <Text type="primary" fontType="title" fontSize={14}>
      {children}
      {isRequired ? <span className={s.mark}>*</span> : null}
    </Text>
  )
}

export default Label
